import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_EMPLOYEE_REQUEST = "GET_EMPLOYEE_REQUEST";
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_ERROR = "GET_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const getEmployeeRequest = (payload = {}, callback) => ({
  type: GET_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const getEmployeeSuccess = (data) => ({
  type: GET_EMPLOYEE_SUCCESS,
  payload: data,
});

export const getEmployeeError = (error) => ({
  type: GET_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const employeeRequest = async (employeeId) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/employees/${employeeId}`, options);
};
